import React, { useContext } from "react";
import { Grid } from "react-feather";
import { Link } from "react-router-dom";
import CustomizerContext from "../../_helper/Customizer";
import { Image } from "../../AbstractElements";
import CubaIcon from "../../assets/images/logo/Murasal_One_Horizontal_Logo_Transparent.png";

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar, toggleIcon, layout, layoutURL } =
    useContext(CustomizerContext);

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  return (
    <div className="logo-wrapper">
      {layout1 !== "compact-wrapper dark-sidebar" &&
      layout1 !== "compact-wrapper color-sidebar" &&
      mixLayout ? (
        <Link to={`${process.env.PUBLIC_URL}/dashboard/${layoutURL}`}>
          <Image
            attrImage={{
              className: "img-fluid d-inline",
              src: `${CubaIcon}`,
              alt: "",
              style: {
                width: "180px", // adjust as needed
                height: "80px",
                objectFit: "contain",
                maxWidth: "100%",
              },
            }}
          />
        </Link>
      ) : (
        <Link to={`${process.env.PUBLIC_URL}/dashboard/${layoutURL}`}>
          <Image
            attrImage={{
              className: "img-fluid d-inline",
              src: `${require("../../assets/images/logo/Logo.svg")}`,
              alt: "",
            }}
          />
        </Link>
      )}
      <div className="back-btn" onClick={() => openCloseSidebar()}>
        <i className="fa fa-angle-left"></i>
      </div>
      <div className="toggle-sidebar" onClick={openCloseSidebar}>
        <Grid className="status_toggle middle sidebar-toggle" />
      </div>
    </div>
  );
};

export default SidebarLogo;
